import useFetchApi from "@/api/hooks/useFetchApi";
import BreadCrumb from "@/components/BreadCrumb";
import ProductCard from "@/components/Cards/ProductCard";
import DropdownListWithApi from "@/components/DDL/DropdownListWithApi";
import Loader from "@/components/Loader/loader";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const ListProduct: React.FC = () => {
    const [treeData, setTreeData] = useState<any | null>(null);
    const { index } = useParams<{ index: string }>();

    const handleRecursive: any = (baseData: any, allItems: any[]) => {
        let { _id } = baseData;
        const children = allItems.filter((item: any) => item.parentId?._id === _id);
        return {
            ...baseData,
            children: children.map((child: any) => handleRecursive(child, allItems)),
        };
    };

    const {
        data: allDatas,
        isLoading,
        error,
    } = useFetchApi({
        url: "/v1/gp/67850933e23ada9e6aa61f3c/tr/find?list_related=false&list_referenced=false&module_populate=677e19dbc44fb038b4a85676&limit=0&skip=0",
        service: "CMS_PROC",
        options: {
            refreshInterval: 0,
            revalidateOnFocus: false,
        },
    });

    useEffect(() => {
        if (!isLoading && allDatas?.results?.length > 0) {
            const cp_data = allDatas.results;
            const rootNode = handleRecursive(cp_data[parseInt(index || "0")], cp_data);

            setTreeData(rootNode);
        }
    }, [isLoading, allDatas, index]);


    const renderRecursive = (node: any) => {
        console.log(node);
        if (node.children && node.children.length > 0) {
            return node.children.map((childNode: any) => {
                return renderRecursive(childNode);
            });
        } else {
            return (

                <ProductCard
                    data={{
                        title: node.title,
                        content: node.content,
                        Ozellikleri: node.ozellikleri,
                        Urun_Gami: node.Urun_Gami,
                        Kullanim_Alani: node.Kullanim_Alani,
                        Depolama: node.Depolama,
                        Tehlike_Aciklamasi: node.Tehlike_Aciklamasi,
                        Acil_Durum: node.Acil_Durum,
                        icon: node.icon,
                        image: node.image,
                        fix_name: node.fix_name,
                        node: true,
                        _id: node._id
                    }}
                    isLoading={false}
                    key={node._id}
                />

            );
        }
    };

    return (
        <>
            <BreadCrumb title="Gazlar" parent="Ürünler" child="Gazlar" />

            {/* <section className="ls">
                <div className="container">
                    <div className="row">

                        <div className="col col-md-3">
                            <DropdownListWithApi
                                url="/v1/gp/67850933e23ada9e6aa61f3c/tr/find?list_related=false&max_depth=0&list_referenced=false&limit=0&skip=0&search=parentId%3A%24eq%3Anull"
                                getText={(item) => item.title}
                                baseUrl={'/list-products'}
                            />
                        </div>
                    </div>
                </div>
            </section> */}


            <section className="ls section_padding_top_135 section_padding_bottom_90 columns_padding_25">
                <div className="container">
                    <div className="row columns_margin_bottom_40 services-row">
                        {isLoading && <Loader />}

                        {!isLoading && treeData && renderRecursive(treeData)}
                    </div>
                </div>
            </section>
        </>
    );
};

export default ListProduct;